import { IconName } from '@infotech-soe/erp-ui-kit';
import { THotKey } from '@infotech-soe/metaschema';

import {
  BuiltinCaptionType,
  Caption,
  CaptionType,
} from '../../../models/caption/Caption';
import RunActionCommandImpl from '../impl/RunActionCommandImpl';

import CategoryCommand from './CategoryCommand';

class PivotCommand extends CategoryCommand<Record<string, any>> {
  constructor(
    commandImpl: RunActionCommandImpl,
    private caption: string,
    private icon?: IconName,
    private menuLabel?: string,
    private hotKey?: THotKey
  ) {
    super(commandImpl);
  }

  public async getCaption(): Promise<Caption> {
    return this.caption === this.getName()
      ? { type: CaptionType.BUILT_IN, caption: BuiltinCaptionType.PIVOT }
      : {
          type: CaptionType.EXTERNAL,
          caption: this.caption,
        };
  }

  public getIcon(): IconName {
    return this.icon ?? 'flexmonster';
  }

  public getMenuLabel(): string | undefined {
    return this.menuLabel;
  }

  public getHotKey(): THotKey | undefined {
    return this.hotKey;
  }

  public getProcessMode(): 'Current' {
    return 'Current';
  }
}

export default PivotCommand;
